
import { defineComponent } from 'vue';
import api from '@/api/my/plugins';
import utils from '@/utils';
import QRCode from 'qrcode';

interface IBuyForm {
  userName: string;
  name: string;
}

interface IPayForm {
  channel: string;
  isPurchased: boolean;
  isQrCode: boolean;
  orderNo: string;
  failureCount: 0;
}

interface IState {
  active: number;
  extensionUrl: string;
  price: number;
  discount: number;
  buyForm: IBuyForm;
  payForm: IPayForm;
}

export default defineComponent({
  name: 'Domains',
  emits: ['close'],
  props: {
    userName: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      active: 0,
      extensionUrl: '',
      price: 0,
      discount: 0,
      buyForm: {} as IBuyForm,
      payForm: {} as IPayForm,
    } as IState;
  },
  methods: {
    apiGet() {
      this.active = 0;
      this.extensionUrl = '';
      this.price = 0;
      this.discount = 0;
      this.buyForm = {} as IBuyForm;
      this.payForm = {} as IPayForm;

      api.buy(
        {
          userName: this.userName,
          name: this.name,
        },
        (res) => {
          if (!res) return;
          this.extensionUrl = res.extensionUrl;
          this.price = res.price;
          this.discount = res.discount;
        },
      );
    },

    getExtensionDiscount(): string {
      return this.discount < 1 ? `（${this.discount * 10}折）` : '';
    },

    getPayAmount(): number {
      return this.price * this.discount;
    },

    getChannel() {
      return this.payForm.channel === 'AliPay' ? '支付宝' : '微信';
    },

    getPayDescription() {
      const amount = this.getPayAmount().toFixed(2);
      return `
        插件名称:
        <span style="color: #fa5300; margin-right: 15px">${this.name}</span>
        费用合计:
        <span style="color: #fa5300">￥${amount}</span>`;
    },

    payQuery() {
      const interval = setInterval(() => {
        api.query(
          {
            orderNo: this.payForm.orderNo,
          },
          (res) => {
            this.payForm.isPurchased = res.isPurchased;

            if (this.payForm.isPurchased) {
              clearInterval(interval);
            }
          },
        );
      }, 3000);
    },

    btnPayChannelClick(channel: string) {
      this.payForm.channel = channel;

      api.pay(
        {
          userName: this.userName,
          name: this.name,
          channel: this.payForm.channel,
          amount: this.getPayAmount(),
        },
        (res) => {
          if (!res) return;

          this.payForm.isQrCode = true;
          this.payForm.orderNo = res.orderNo;

          setTimeout(() => {
            QRCode.toCanvas(document.getElementById('qrcode'), res.qrCodeUrl, { width: 260 });
          }, 100);

          this.payQuery();
        },
        (error) => {
          console.log(error);
          this.payForm.failureCount += 1;
          if (this.payForm.failureCount < 3) {
            this.btnPayChannelClick(channel);
          } else {
            utils.loading(false);
            utils.error(error);
          }
        },
      );
    },

    btnNextClick() {
      this.active += 1;
      this.payForm.failureCount = 0;
    },

    btnPayCloseClick() {
      this.$emit('close');
    },
  },
  watch: {
    userName: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.apiGet();
        }
      },
      deep: false,
    },
    name: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.apiGet();
        }
      },
      deep: false,
    },
  },
  mounted() {
    this.apiGet();
  },
});
